/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Import_File_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "File Import" |
*
* @param {Toolbar_Secondary_Import_File_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_import_file_aria_label = /** @type {((inputs?: Toolbar_Secondary_Import_File_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Import_File_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Importation de Fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dateiimport")
	if (locale === "it") return /** @type {LocalizedString} */ ("Importazione file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Импорт файлов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Importación de archivos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("文件导入")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルのインポート")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल आयात")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Importação de Arquivos")
	return /** @type {LocalizedString} */ ("File Import")
});